export const Gender = {
  Male: 0,
  Female: 1
};

export const DoctorType = {
  Doctor: 0,
  Therapist: 1
};
